import React from "react";
import styled from "styled-components";

import themeGet from "@/utils/theme-gets";

import { DATA_LIST_OPTION_HOVERED, DATA_LIST_OPTION_SELECTED } from "../../../hooks/useListOptionHighlight";
import type { PolymorphicBoardOption } from "../../../hooks/usePolyBoardOptions";
import type { BoardDropdownPolyOption } from "../../../hooks/usePolyBoardOptions";
import type { VirtualizeOptionProps } from "../../../models/VirtualizeOptionStyle";
import { BoardValue } from "./BoardValue";

export const BoardOption: React.FC<PolymorphicBoardOption & VirtualizeOptionProps> = ({
  virtualizedStyle,
  index,
  ...props
}) => {
  const { isSelected, onClick, ...rest } = props.board as BoardDropdownPolyOption;

  const onClickInternal = () => {
    onClick?.(props);
  };

  return (
    <BoardOptionWrapper
      data-list-option={index}
      data-list-option-selected={isSelected || undefined}
      style={virtualizedStyle}
      onClick={onClickInternal}
    >
      <BoardValue {...rest} />
    </BoardOptionWrapper>
  );
};

const BoardOptionWrapper = styled.div`
  cursor: pointer;

  width: calc(100% - 2 * ${themeGet("spacing.s")}) !important;
  margin: 0 ${themeGet("spacing.s")};

  &[${DATA_LIST_OPTION_SELECTED}] {
    background-color: ${themeGet("color.background.interaction.active")};
    border-color: ${themeGet("color.border.layout.subtle")};
    border-radius: ${themeGet("radii.s")};
  }

  &:not(&[${DATA_LIST_OPTION_SELECTED}]) {
    &[${DATA_LIST_OPTION_HOVERED}] {
      background-color: ${themeGet("color.background.interaction.hover")};
      border-color: ${themeGet("color.border.layout.subtle")};
      border-radius: ${themeGet("radii.s")};
    }
  }
`;
